import { createBrowserRouter } from "react-router-dom";
import Home from "@/routes/Home";
import NotFound from "@/routes/NotFound";
import Admin from "@/routes/Admin";
// StudioCreate (routed at /create/advanced) is the deliberately-kept ADVANCED create
// surface: it consumes the SAME shared pipeline as the streamlined CreateScreen
// (runGeneration / saveGeneratedRoast) but additionally exposes the per-roast controls
// the new flow hardcodes to defaults — name, context, profanity, length, voice, aspect,
// doodle. Do NOT delete: it's the home for those controls until they're folded into
// CreateScreen (as an "advanced" affordance) and/or this route is gated behind admin.
import StudioCreate from "@/routes/StudioCreate";
import CreateScreen from "@/routes/CreateScreen";
import Processing from "@/routes/Processing";
import Player from "@/routes/Player";
import Library from "@/routes/Library";
import RequireAuth from "@/routes/RequireAuth";
import Replay from "@/routes/Replay";
import DevPlayer from "@/routes/DevPlayer";
import DevCapture from "@/routes/DevCapture";
import LoaderDev from "@/routes/LoaderDev";
import DevMobile from "@/routes/DevMobile";
import RootLayout from "@/routes/RootLayout";

export const router = createBrowserRouter([
  {
    // Root layout hosts the always-present <IgnitionOverlay> above every route, so the
    // completion transition persists across the Processing → Player swap.
    element: <RootLayout />,
    children: [
      { path: "/", element: <Home /> },
      {
        element: <RequireAuth />,
        children: [
          { path: "/create", element: <CreateScreen /> },
          { path: "/create/advanced", element: <StudioCreate /> },
          { path: "/processing", element: <Processing /> },
          { path: "/player", element: <Player /> },
          { path: "/library", element: <Library /> },
          { path: "/admin", element: <Admin /> },
          { path: "/r/:id", element: <Replay /> },
        ],
      },
      { path: "/404", element: <NotFound /> },
      ...(import.meta.env.DEV ? [{ path: "/dev/player", element: <DevPlayer /> }] : []),
      ...(import.meta.env.DEV ? [{ path: "/dev/capture", element: <DevCapture /> }] : []),
      ...(import.meta.env.DEV ? [{ path: "/dev/loader", element: <LoaderDev /> }] : []),
      ...(import.meta.env.DEV ? [{ path: "/dev/mobile", element: <DevMobile /> }] : []),
      { path: "*", element: <NotFound /> },
    ],
  },
]);
